import { useQuery } from '@tanstack/react-query'
import { api } from '@/lib/api'
import type { FollowUpSuggestionsResponse } from '@/lib/types'

export function useFollowUpSuggestions(options?: {
  limit?: number
  ai?: boolean
  enabled?: boolean
}) {
  const { limit = 5, ai = false, enabled = true } = options ?? {}

  const params = new URLSearchParams()
  params.set('limit', String(limit))
  if (ai) params.set('ai', 'true')

  return useQuery({
    queryKey: ['follow-up-suggestions', limit, ai],
    queryFn: () =>
      api<FollowUpSuggestionsResponse>(`/api/contacts/follow-up-suggestions?${params}`),
    enabled,
    staleTime: 1000 * 60 * 5, // 5 min
  })
}
